import { Component }                 from '@angular/core';
import { Tenant }                    from '@app/modules/admin-tenant/models/tenant.model';
import { TenantHelperService }       from '@app/modules/admin-tenant/services/tenant-helper.service';
import {
	IBaseHttpParams,
	RequestCompleteListState
}                                    from '@core/interfaces/api.interface';
import { SelectFilterBaseComponent } from '@shared/list-operations/components/select-filters/select-filter-base/select-filter-base.component';
import { ISelectFilterable }         from '@shared/list-operations/model/filter.model';
import { Observable }                from 'rxjs';

@Component( {
	selector: 'app-select-filter-tenant',
	templateUrl: './../select-filter-base/select-filter-base.component.html'
} )
export class SelectFilterTenantComponent extends SelectFilterBaseComponent implements ISelectFilterable {

	constructor(
		private readonly tenantHelperService: TenantHelperService
	) {
		super();
	}

	searchRequestCallback = ( searchRequestParams: IBaseHttpParams ): Observable<RequestCompleteListState<Tenant>> => {
		// TODO check if selection of tenant service should be based on current user's role or not
		return this.tenantHelperService.currentUsersRoleBasedTenantService.search(
			searchRequestParams,
			'SelectFilterTenantComponent:searchRequestCallback',
			{ updateStore: false }
		);
	};
}
